import { Outlet } from 'react-router-dom';

import { useDashboardViewInit } from './utils/useDashboardViewInit';

export const DashboardView = (): JSX.Element | null => {
  const { isInitialized } = useDashboardViewInit();

  if (!isInitialized) {
    return null;
  }

  return <Outlet />;
};
